const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		mid: null,
		page: 1
	},
	methods: {
		getParams: function () {
			this.mid = listMid;
			this.page = listPage;
			this.pid = listPid;
			this.type = listType;
		},
		turnPage: function (page) {
			const hList = location.href.split('/')
			const t = hList[hList.length-1]
			const newT = '' + this.mid + '-' + page + '-' + this.pid + '-' + this.type + '.html'

			location.href = location.href.replace(t, newT);
		}
	},
	mounted: function () {
		this.getParams();
	}
});